import React from "react";
import { Formik, Field, Form } from "formik";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeading,
    ModalSubHeading,
    CalendarIcon,
    RupeeIcon
} from "../Styles/InputStyle2";
import DropzoneImageUpload from "../Properties/DropzoneImageUpload";
import tw from "tailwind-styled-components";
import { toast, ToastContainer } from "react-toastify";

const SupportingDocument = ({ onClose, stepOneData,setSelectedForm,setFormData, formData }) => {
    const initialValues = {
        invoice: null,
        Warranty: null,
        assets: null,

    };
    const handleBack = () =>{
        setSelectedForm("4");
    }

    const handleSubmit = (values) => {
        toast.success("Form Submitted Successfully");
        console.log("final data :", formData);
        setFormData((prevFormData) => ({
            ...prevFormData,
            supportingDocument: values,
        }));

    };

    return (
        <Formik initialValues={stepOneData || initialValues} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
                <Form>
                    <ModalSubHeading>Step 5</ModalSubHeading>
                    <ModalHeading>Supporting Documents Details</ModalHeading>
                    <ScrollableContent>
                        <Wrapper>
                            <InputGroup>
                                <Label htmlFor="invoice">
                                    Upload Invoice 
                                </Label>
                                <div>
                                    <DropzoneImageUpload
                                        setUploadFile={(file) => (values.tenantDocumentImage = file)}
                                        componentFor="invoice"
                                    />
                                </div>
                            </InputGroup>
                            <InputGroup>
                                <Label htmlFor="Warranty">
                                    Warranty Document 
                                </Label>
                                <div>
                                    <DropzoneImageUpload
                                        setUploadFile={(file) => (values.tenantDocumentImage = file)}
                                        componentFor="Warranty"
                                    />
                                </div>
                            </InputGroup>
                            <InputGroup>
                                <Label htmlFor="assets">
                                    Upload Asset Images 
                                </Label>
                                <div>
                                    <DropzoneImageUpload
                                        setUploadFile={(file) => (values.tenantDocumentImage = file)}
                                        componentFor="assets"
                                    />
                                </div>
                            </InputGroup>
                        </Wrapper>
                    </ScrollableContent>
                    <ActionSection>
                        <SideCancelBtn type="button" onClick={handleBack}>
                            Back
                        </SideCancelBtn>
                        <SubmitBtn type="submit">
                            Submit
                        </SubmitBtn>
                    </ActionSection>
                </Form>
            )}
        </Formik>
    );
};
const Vendor = tw.button`text-blue-500 text-sm flex hover:underline`


export default SupportingDocument;